function getRandomInt(max) {
  return Math.floor(Math.random() * max); // 0-basiert zurückgeben
}

document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll('.shopify-section.shopify-section--media-grid');

  if (sections.length > 1) {
    const randomIndex = getRandomInt(sections.length);
    let randomIndex2;

    do {
      randomIndex2 = getRandomInt(sections.length);
    } while (randomIndex2 === randomIndex);

    sections[randomIndex].style.display = "block";
    sections[randomIndex2].style.display = "block";
  }

  const slideshows = document.querySelectorAll('.shopify-section--slideshow.container');

  if (slideshows.length > 0) {
    const randomIndex = getRandomInt(slideshows.length);
    slideshows[randomIndex].classList.add("show_me");
  }
});